export enum AllocationModeFlag {
  Formula = 'Formula',
  Expenses = 'Expenses'
}

export interface AllocationModeFlags {
  [AllocationModeFlag.Formula]: boolean;
  [AllocationModeFlag.Expenses]: boolean;
}
